<template>
  <b-modal ref="global-setting-card-modal" @ok="globalSettingCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.globalSettings.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.globalSettings.tableColumns.name"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="globalSetting.name"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.globalSettings.tableColumns.value"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="value"
          :state="isValueValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="globalSetting.executor"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateGlobalSettingPage",
  props: {
    globalSetting: Object,
  },
  components: {},
  data() {
    return {
      value: null,
      isValueValid: null,
      created: null,
      updated: null
    };
  },
  methods: {
    async open() {
      this.value = this.globalSetting.value;

      this.isValueValid = null;

      this.created = utilsService.formatDateTime(new Date(this.globalSetting.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.globalSetting.updated * 1000), utilsService.DATE_TIME_FORMAT);

      this.$refs["global-setting-card-modal"].show();
    },
    async globalSettingCardModalOk(event) {
      if (!this.globalSetting.value) {
        this.isValueValid = false;
        event.preventDefault();
        return;
      } else {
        this.isValueValid = null;
      }

      const globalSettings = [];
      this.globalSetting.value = this.value;

      globalSettings.push(this.globalSetting);

      const updateGlobalSettingResponse = await azkService.updateGlobalSettings(globalSettings);

      if (
        updateGlobalSettingResponse.isSuccess &&
        updateGlobalSettingResponse.data &&
        updateGlobalSettingResponse.data.countInsertedRows == 1
      ) {
        this.$emit("globalSettingUpdatedSuccessEvent");
      } else {
        this.$emit("globalSettingUpdatedFailEvent");
      }
    },
  },
};
</script>
